export default "__VITE_ASSET__D3uc0W6e__"